import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { App } from '@/app/App'
import { Providers } from '@/app/Providers'
// Шрифты самохостятся: в мини-аппе внутри Telegram каждый внешний домен —
// это лишний DNS + TLS на медленной сети, а нам нужен первый экран сразу.
import '@fontsource-variable/golos-text'
import '@fontsource/alice/400.css'
import '@fontsource-variable/caveat'
import '@/shared/theme.css'

async function bootstrap() {
  // Демо-режим существует только в dev-сборке: в production условие
  // вычисляется в false и модуль в бандл не попадает.
  if (import.meta.env.DEV) {
    const { setupDemo } = await import('@/dev/mock')
    setupDemo()
  }

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <BrowserRouter>
        <Providers>
          <App />
        </Providers>
      </BrowserRouter>
    </StrictMode>,
  )
}

void bootstrap()
